import React, { useContext, useEffect } from 'react';
import { AccountContext } from '../../../../components/AccountContext';
import { useHistory } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { InputNumberComponent } from '../../../../components/prime-formik';
import { UPDATE_ORGANISATION_SIZE_MUTATION } from '../../services/dashboard.service';
import { growlActionSuccess, growlErrors } from '../../../../utils/NotificationUtil';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import { useMutation } from '@apollo/react-hooks';

const NoDataAccountOrganisationSizeNotification = ({ updateNotification }) => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const history = useHistory();

  const [updateAccountOrganisationSize] = useMutation(UPDATE_ORGANISATION_SIZE_MUTATION);

  const initialValues = {
    organisationSize: null,
  };

  const validationSchema = Yup.object().shape({
    organisationSize: Yup.number().required(),
  });

  const updateOrganisationSize = async (values) => {
    try {
      await updateAccountOrganisationSize({
        variables: {
          input: {
            accountId: currentAccount,
            organisationSize: values.organisationSize,
          },
        },
      });

      updateNotification();
      history.push(`/accounts/${currentAccount}`);
      growlActionSuccess(growl);
    } catch (error) {
      growlErrors(growl, error);
    }
  };

  useEffect(() => {
    document.querySelector('#organisationSize').focus();
  });

  return (
    <div className="center">
      <p>
        We kindly ask you to enter the total number of long-term relations in your organisation e.g., total number of
        employees in your company, total number of employees and enrolled students at your university, etc.
      </p>
      <p>
        We use the number you enter to help your organisation in being data privacy compliant. For example, if the
        actual number of Internal Respondents exceeds the number you enter, we will notify you so you can take
        appropriate action, if required.
      </p>
      <p>
        {
          'You can always adjust the number at your own initiative at Account management -> Accounts -> Settings for this account.'
        }
      </p>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => updateOrganisationSize(values)}
      >
        <Form>
          <div className="grid">
            <div className="p-col-12">
              <Field
                id="organisationSize"
                name="organisationSize"
                type="number"
                min="1"
                component={InputNumberComponent}
              />
            </div>
          </div>
          <Button type="submit" className="p-button-primary" label="ADD NUMBER NOW" />
        </Form>
      </Formik>
    </div>
  );
};

export default NoDataAccountOrganisationSizeNotification;
